// UTM parameter utilities

export interface UTMData {
  utmCampaign?: string;
  utmSource?: string;
  utmMedium?: string;
  utmTerm?: string;
  utmContent?: string;
}

/**
 * Extract UTM parameters from the current URL
 */
export const getUTMParameters = (): UTMData => {
  const urlParams = new URLSearchParams(window.location.search);
  
  return {
    utmCampaign: urlParams.get('utm_campaign') || undefined,
    utmSource: urlParams.get('utm_source') || undefined,
    utmMedium: urlParams.get('utm_medium') || undefined,
    utmTerm: urlParams.get('utm_term') || undefined,
    utmContent: urlParams.get('utm_content') || undefined,
  };
};

/**
 * Check if any UTM parameters are present in the URL
 */
export const hasUTMParameters = (): boolean => {
  const utmData = getUTMParameters();
  return Object.values(utmData).some(value => value !== undefined);
};

/**
 * Save UTM parameters to localStorage
 */
export const saveUTMParameters = (utmData: UTMData): void => {
  try {
    const serializedData = JSON.stringify(utmData);
    localStorage.setItem('utmData', serializedData);
  } catch (error) {
    console.error('Could not save UTM data to localStorage:', error);
  }
};

/**
 * Load UTM parameters from localStorage
 */
export const loadUTMParameters = (): UTMData | null => {
  try {
    const serializedData = localStorage.getItem('utmData');
    if (serializedData === null) {
      return null;
    }
    return JSON.parse(serializedData);
  } catch (error) {
    console.error('Could not load UTM data from localStorage:', error);
    return null;
  }
};

/**
 * Clear UTM parameters from localStorage
 */
export const clearUTMParameters = (): void => {
  try {
    localStorage.removeItem('utmData');
  } catch (error) {
    console.error('Could not clear UTM data from localStorage:', error);
  }
};